import { graphql } from "api/cms-website/generated";

export const PriceBlockFragment = graphql(/* GraphQL */ `
    fragment PriceBlockFragment on ComponentComponentsPriceBlock {
        id
        title
        subtitle
        hideCasesList
        hideMonthlyPrice
        hideDurationGraph
        hideBiteCorrection
        hideCaseFullName
        alwaysShowTnC
        casesList {
            ...TextFragment
        }
        detailsList {
            label
            value
        }
    }
`);
